/* eslint-disable no-unused-vars */
import React from 'react';
import {
  VStack,
  SimpleGrid,
  FormControl,
  FormLabel,
  Input,
  Flex,
  Button,
  Box,
  Switch,
  Text,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { motion } from 'framer-motion';
import Card from 'components/card/Card';
import { AddIcon } from '@chakra-ui/icons';

const MotionBox = motion(Box);

const DoctorForm = ({ onSubmit }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    defaultValues: { active: true },
  });
  const activeValue = watch('active');

  return (
    <Box w="100%" h="100%" p={2}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex justify="center">
          <MotionBox
            w={{ base: '100%', md: '100%' }}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.25 }}
          >
            <Card
              bg="white"
              shadow="lg"
              borderRadius="lg"
              p={6}
              border="1px solid"
              borderColor="gray.200"
            >
              <VStack spacing={4} align="stretch">
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                  <FormControl isRequired>
                    <FormLabel>Name</FormLabel>
                    <Input
                      placeholder="Enter Doctor Name"
                      {...register('name', {
                        required: 'Name is required',
                        minLength: { value: 3, message: 'Min 3 characters' },
                      })}
                      borderColor={errors.name && 'red.400'}
                    />
                    {errors.name && (
                      <Text fontSize="xs" color="red.500">
                        {errors.name.message}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel>Specialty</FormLabel>
                    <Input
                      placeholder="Enter Specialty"
                      {...register('specialty', {
                        required: 'Specialty is required',
                      })}
                      borderColor={errors.specialty && 'red.400'}
                    />
                    {errors.specialty && (
                      <Text fontSize="xs" color="red.500">
                        {errors.specialty.message}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel>Hospital</FormLabel>
                    <Input
                      placeholder="Enter Hospital Name"
                      {...register('hospital', {
                        required: 'Hospital is required',
                      })}
                      borderColor={errors.hospital && 'red.400'}
                    />
                    {errors.hospital && (
                      <Text fontSize="xs" color="red.500">
                        {errors.hospital.message}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel>City</FormLabel>
                    <Input
                      placeholder="Enter City"
                      {...register('city', {
                        required: 'City is required',
                      })}
                      borderColor={errors.city && 'red.400'}
                    />
                    {errors.city && (
                      <Text fontSize="xs" color="red.500">
                        {errors.city.message}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel>Phone</FormLabel>
                    <Input
                      placeholder="Enter Phone Number"
                      {...register('phone', {
                        required: 'Phone is required',
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: 'Enter valid 10-digit number',
                        },
                      })}
                      borderColor={errors.phone && 'red.400'}
                    />
                    {errors.phone && (
                      <Text fontSize="xs" color="red.500">
                        {errors.phone.message}
                      </Text>
                    )}
                  </FormControl>
                </SimpleGrid>

                <Flex justify="center" mt={2}>
                  <Button
                    type="submit"
                    colorScheme="teal"
                    isLoading={isSubmitting}
                    w="160px"
                  >
                    Submit
                  </Button>
                </Flex>
              </VStack>
            </Card>
          </MotionBox>
        </Flex>
      </form>
    </Box>
  );
};

export default DoctorForm;
